import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logo_yellow.svg")